module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/rcBumper-9f864eebd1867e65bb8f5bced2341195.png";